import React from 'react'

import { graphql, useStaticQuery } from 'gatsby'

import TestimonialSlider from '../reusables/TestimonialSlider'

const EmployerTestimonials = (props) => {
  const query = useStaticQuery(graphql`{
  kimP: file(relativePath: {eq: "employer-partners/kimberly-p.jpg"}) {
    childImageSharp {
      gatsbyImageData(placeholder: NONE, layout: CONSTRAINED, width: 700)
    }
  }
  sheenaG: file(relativePath: {eq: "employer-partners/sheena-gatzke.jpg"}) {
    childImageSharp {
      gatsbyImageData(placeholder: NONE, layout: CONSTRAINED, width: 700)
    }
  }
  toniaB: file(relativePath: {eq: "employer-partners/tonia-b.jpg"}) {
    childImageSharp {
      gatsbyImageData(placeholder: NONE, layout: CONSTRAINED, width: 700)
    }
  }
  stacyH: file(relativePath: {eq: "employer-partners/stacy-h.jpg"}) {
    childImageSharp {
      gatsbyImageData(placeholder: NONE, layout: CONSTRAINED, width: 700)
    }
  }
}
`)

  const testimonials = [
    {
      node: {
        excerpt: "<p>I like what UMA stands for. It's not just about teaching someone how to do something -- UMA has a commitment to the success of its graduates.</p>",
        featuredImage: {
          node: {
            localFile: {
              childImageSharp: {
                gatsbyImageData: query.kimP.childImageSharp.gatsbyImageData,
              },
            },
          },
        },
        metaReviewerName: 'Kimberly Powell, Change Healthcare Director of Remote Resource Engagement',
        metaReviewerVideo: 'dp_z8Fwx2pk',
      },
    },
    {
      node: {
        excerpt: '<p>We can count on these UMA grads to come through and to start in the role and do well.</p>',
        featuredImage: {
          node: {
            localFile: {
              childImageSharp: {
                gatsbyImageData: query.sheenaG.childImageSharp.gatsbyImageData,
              },
            },
          },
        },
        metaReviewerName: 'Sheena Gatzke, Walgreens Client Services Manager',
        metaReviewerVideo: '5-tnj59h9GA',
      },
    },
    {
      node: {
        excerpt: "<p>UMA's partnership has been instrumental in our overall success.</p>",
        featuredImage: {
          node: {
            localFile: {
              childImageSharp: {
                gatsbyImageData: query.toniaB.childImageSharp.gatsbyImageData,
              },
            },
          },
        },
        metaReviewerName: 'Tonia Byrd, Episource Director of Record Retrieval',
        metaReviewerVideo: 'pUmfibE9FVU',
      },
    },
    {
      node: {
        excerpt: "<p>I really like the partnership with UMA because it's very collaborative, thought-provoking, innovative... Our partnership has been one of really great direction and dialog.</p>",
        featuredImage: {
          node: {
            localFile: {
              childImageSharp: {
                gatsbyImageData: query.stacyH.childImageSharp.gatsbyImageData,
              },
            },
          },
        },
        metaReviewerName: 'Stacy Hodge, BroadPath Healthcare Solutions',
        metaReviewerVideo: 'E2obStieI8g',
      },
    },
  ]

  return (
    <TestimonialSlider
      className="text-white-force"
      employer
      heading="What our partners say about us."
      testimonials={testimonials} />
  )
}

export default EmployerTestimonials
